import React, { useEffect, useState } from "react";
import { api, euroFormat } from "../../lib/api";
import { Download, ArrowUpDown, Trophy } from "lucide-react";

const PERIODS = [
  { value: "all", label: "Gesamt" },
  { value: "year", label: "Jahr" },
  { value: "quarter", label: "Quartal" },
  { value: "month", label: "Monat" },
];
const SORTS = [
  { value: "abschluesse", label: "Abschlüsse" },
  { value: "coins", label: "FalkeCoins" },
  { value: "stufe", label: "Stufe" },
  { value: "auftrag", label: "Auftragssumme" },
];

export default function VertrieblerLeaderboard() {
  const [period, setPeriod] = useState("all");
  const [sortBy, setSortBy] = useState("abschluesse");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/vertriebler/leaderboard", { params: { period, sort_by: sortBy } }).then((r) => setItems(r.data));
  }, [period, sortBy]);

  const exportCSV = () => {
    const header = ["Rang", "Name", "E-Mail", "Stufe", "Modus", "Abschlüsse", "Auftragssumme Netto", "Gesammelte Coins", "Verfügbare Coins"];
    const sep = ";";
    const rows = items.map((e) => [
      e.rang, e.name, e.email, e.stufe || "—", e.tippgeber_modus, e.abschluesse,
      String(e.auftragssumme_netto).replace(".", ","), e.gesammelte_coins, e.verfuegbare_coins,
    ]);
    const csv = "\uFEFF" + [header, ...rows].map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(sep)).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `Leaderboard_${period}_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-5" data-testid="vertriebler-leaderboard-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <Trophy className="text-falke-orange" size={28} />
          <div>
            <h1 className="text-3xl font-heading font-bold text-falke-blue">Leaderboard</h1>
            <p className="text-sm text-falke-anthracite/70">Alle Empfehler im Überblick</p>
          </div>
        </div>
        <button onClick={exportCSV} className="btn-outline inline-flex items-center gap-2" data-testid="leaderboard-csv-export"><Download size={16} /> CSV-Export</button>
      </div>

      <div className="flex flex-wrap gap-3">
        <div className="inline-flex bg-white rounded-xl p-1 border border-falke-blue/10 text-sm">
          {PERIODS.map((p) => (
            <button key={p.value} onClick={() => setPeriod(p.value)} className={`px-3 py-1.5 rounded-lg font-semibold ${period === p.value ? "bg-falke-orange text-white" : "text-falke-blue"}`} data-testid={`period-${p.value}`}>{p.label}</button>
          ))}
        </div>
        <div className="inline-flex bg-white rounded-xl p-1 border border-falke-blue/10 text-sm">
          {SORTS.map((s) => (
            <button key={s.value} onClick={() => setSortBy(s.value)} className={`px-3 py-1.5 rounded-lg font-semibold inline-flex items-center gap-1 ${sortBy === s.value ? "bg-falke-orange text-white" : "text-falke-blue"}`} data-testid={`sort-${s.value}`}>
              <ArrowUpDown size={12} /> {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="falke-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-falke-blue/70 text-xs uppercase tracking-wider border-b border-falke-blue/10">
            <tr><th className="px-4 py-3">Rang</th><th>Name</th><th>E-Mail</th><th>Stufe</th><th>Modus</th><th>Abschlüsse</th><th>Auftrag (netto)</th><th>Coins ges.</th><th>Coins frei</th></tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.user_id} className="border-t border-falke-blue/5" data-testid={`lb-row-${e.user_id}`}>
                <td className="px-4 py-3 font-heading font-bold tabular text-falke-blue">{e.rang}</td>
                <td className="font-medium">{e.name}</td>
                <td className="text-xs">{e.email}</td>
                <td><span className={`status-badge ${e.stufe ? "bg-falke-orange/15 text-falke-orange" : "bg-gray-100 text-gray-500"}`}>{e.stufe || "—"}</span></td>
                <td className="text-xs">{e.tippgeber_modus}</td>
                <td className="tabular font-bold">{e.abschluesse}</td>
                <td className="tabular">{euroFormat(e.auftragssumme_netto)}</td>
                <td className="tabular">{e.gesammelte_coins}</td>
                <td className="tabular text-falke-orange font-semibold">{e.verfuegbare_coins}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={9} className="px-4 py-10 text-center text-falke-anthracite/60">Keine Daten.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
